import { render } from "./stepAccount.vue?vue&type=template&id=8765829e"
import script from "./stepAccount.vue?vue&type=script&lang=js"
export * from "./stepAccount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__